<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-edit-general v-if="user !== null" :passData="user" :levels="listLevel" />
      </div>
    </vs-tab>
    <vs-tab v-if="idUser !== ''" icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Change Password' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-edit-password v-if="user !== null" :passData="user" />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import UserEditGeneral from './UserEditGeneral.vue'
import UserEditPassword from './UserEditPassword.vue'

export default {
  components: {
    UserEditGeneral,
    UserEditPassword,
  },
  props : {
    idUser : {type: String, default: ""}
  },
  data () {
    return {
      user : null,
      listLevel : []
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  methods : {
    getLevels() {
      this.$store
        .dispatch("level/getLevel", {})
        .then((v) => {
          console.log(v)
          this.listLevel = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getUsers() {
      this.$store
        .dispatch("users/getUsers", {id : Number.parseInt(this.idUser)})
        .then((v) => {
          console.log(v)
          this.user = v
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted () {
    if (this.$store.state.level.kategoriList.length !== 0) {
      console.log(this.$store.state.level.kategoriList)
      this.listLevel = this.$store.state.level.kategoriList;
    } else {
      this.getLevels();
    }
  },
  created () {
    if(this.idUser !== null){
      this.getUsers()
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
